import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnObjectInfo } from '../base';

export class SnTagRecord extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => SnObjectInfo)
  public objectInfo: SnObjectInfo;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
